import { apiClient } from "./config";

/**
 * Get list templates plans content presets
 * @param params
 * @param successCallback
 * @param errorCallback
 * @returns {Promise<*>}
 */
export const getListTemplatesPlansContentPresets = async (
	params,
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, ...body } = params;

	try {
		const response = await apiClient.get(`/admin/templates/plans/${templatePlan}/content-presets`, {
			params: body,
		});
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Create new templates plans content presets
 * @param {title, organization_type_id, description, id, templatePlan} body
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const createTemplatesPlansContentPresets = async (
	body,
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, ...data } = body;

	try {
		const response = await apiClient.post(
			`/admin/templates/plans/${templatePlan}/content-presets`,
			data
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Get templates plans content presets
 * @param params
 * @param successCallback
 * @param errorCallback
 * @returns {Promise<*>}
 */
export const getTemplatesPlansContentPresets = async (
	params,
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, contentPreset, ...body } = params;

	try {
		const response = await apiClient.get(
			`/admin/templates/plans/${templatePlan}/content-presets/${contentPreset}`,
			{ params: body }
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Edit templates plan content presets
 * @param {title, organization_type_id, description, id, templatePlan, contentPreset} body
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const editTemplatesPlansContentPresets = async (
	body,
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, contentPreset, ...data } = body;

	try {
		const response = await apiClient.patch(
			`/admin/templates/plans/${templatePlan}/content-presets/${contentPreset}`,
			data
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Delete template plan content presets
 * @param {templatePlan, contentPreset} params
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const deleteTemplatesPlansContentPresets = async (
	params,
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, contentPreset } = params;
	try {
		const response = await apiClient.delete(
			`/admin/templates/plans/${templatePlan}/content-presets/${contentPreset}`
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};
